import { ISignupExisitingAccount } from 'src/types'
import { ExistingAccountTooltip } from '../existing-account-tooltip'
import { HelperWrapper } from '../helper-wrapper'
import { useStyles } from './styles'

interface IProps {
  existingAccount: ISignupExisitingAccount
}

export const AccountExistInfo = ({ existingAccount }: IProps) => {
  const classes = useStyles()

  return (
    <div className={classes.accountWarning}>
      <HelperWrapper t="account-create-exists-1" />
      <ExistingAccountTooltip existingAccount={existingAccount} />
    </div>
  )
}
